import { render, staticRenderFns } from "./interactiveanswer.vue?vue&type=template&id=bff319de&scoped=true"
import script from "./interactiveanswer.vue?vue&type=script&lang=js"
export * from "./interactiveanswer.vue?vue&type=script&lang=js"
import style0 from "./interactiveanswer.vue?vue&type=style&index=0&id=bff319de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff319de",
  null
  
)

export default component.exports